<template>
  <PageContainer>
    <EditarCita @exito="handleExitoCita" :cliente="cliente" @cerrar="cerrarEditarCita" v-if="showEditarCita" />
    <ConfirmarNuevo @cerrar="cerrarConfirmacionNuevo" @aceptar="handleNuevo" :cliente="dataCliente"  v-if="showConfirmarNuevo" />
    <RegistrarCliente @exito="handleExitoRegistrar" v-if="showRegistrarCliente" @cerrar="cerrarRegistrar" @regresar="handleRegresar" />
    <CrearCita :dataCliente="dataCliente"  @falla="fallaCrearCita" @exito="exitoCrearCita" @cerrar="cerrarCrearCita" v-if="showCrearCita" @registrar="handleRegistrar" />
    <EditarStatus @editar="editarStatus" @cerrar="closeModal" :status="statusSeleccionado" v-if="showEditar"/>
    <ModalExito v-if="showModalExito" @cerrar="closeModalExito" :mensaje="mensajeExito"/>
    <ModalError v-if="showModalError" @cerrar="closeModalExito" :mensaje="mensajeError" />
    <Filtros @busqueda="handleBusqueda" @status="handleStatus" @dates="handleDates" />
    <Spinner class="position" :clase="false" v-if="loading"/>
    <div class="table-wraapper">
    <Table message="No se encontraron citas" @editarCita="handleEditarCita" @status="editStatus" :loading="loading" :data="citas" :headers="headers" />
    <div class="footer-container">
      <img class="btn-cita" @click="showCrear" src="../assets/imgs/icons/icono-addCita.svg" />
    <PaginatorFooter id="footer" @paginationData="searchNewPage" :totalPages="totalPages" :fatherPage="page" />
  </div>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../components/citas/CitasContainer.vue'
import Spinner from '../components/Loaders/spinner.vue'
import Filtros from "../components/citas/Filtros.vue"
import Table from '../components/general/tables/Table.vue'
import EditarStatus from '../components/citas/EditarStatus.vue'
import AppoinmentService from "../services/appoinmentService"
import moment from 'moment'
import ModalExito from '../components/Modales/ModalExito.vue'
import ModalError from '../components/Modales/ModalError.vue'
import PaginatorFooter from '../components/general/tables/PaginatorFooter.vue'
import CrearCita from '../components/citas/CrearCita.vue'
import RegistrarCliente from '../components/citas/RegistrarCliente.vue'
import ConfirmarNuevo from '../components/citas/ConfirmarNuevo.vue'
import EditarCita from '../components/citas/EditarCita.vue'
export default {
components:{
    PageContainer,
    Filtros,
    Spinner,
    Table,
    EditarStatus,
    ModalExito,
    ModalError,
    PaginatorFooter,
    CrearCita,
    RegistrarCliente,
    ConfirmarNuevo,
    EditarCita
},
data(){
    return{
        loading:false,
        busqueda:"",
        status:4,
        page:1,
        statusSeleccionado:{},
        citas:[],
        totalPages:1,
        fechaInicio:moment().startOf("month").format("DD-MM-YYYY"),
        fechaFin:moment().endOf("month").format("DD-MM-YYYY"),
        headers: [{text:"Nombre",class:"center-table"}, {text:"Teléfono",class:"hide-tablet hide-movil center-table"}, {text:"Fecha",class:"hide-movil center-table"}, {text:"Hora",class:"hide-tablet hide-movil center-table"},{text:"Estatus de la cita",class:"hide-tablet hide-movil center-table"},{text:"Acciones",class:"center-table"},{text:"",class:"hide-web arrow center-table"}],
        showEditar:false,
        showModalExito:false,
        showModalError:false,
        mensajeError:'',
        mensajeExito:"",
        showCrearCita:false,
        dataCliente:null,
        showRegistrarCliente:false,
        showConfirmarNuevo:false,
        showEditarCita:false,
        cliente:{}
    }
},
methods:{
  closeModal(){
    this.showEditar = false
    this.citas = []
    this.getAppoinments()
  },
  handleExitoCita(msg){
    this.getAppoinments()
    this.showEditarCita = false
    this.showModalExito = true
    this.mensajeExito = msg
  },
  cerrarEditarCita(){
    this.showEditarCita = false
  },
  handleEditarCita(item){
    this.showEditarCita = true
    this.cliente = item
  },
  cerrarConfirmacionNuevo(){
    this.showConfirmarNuevo = false
    this.dataCliente = null
  },
  handleNuevo(){
    this.showConfirmarNuevo = false
        this.showCrearCita = true
  },
  handleRegistrar(){
    this.dataCliente = null
    this.showCrearCita = false
    this.showRegistrarCliente = true
  },
  handleRegresar(){
    this.showRegistrarCliente = false
    this.showCrearCita = true
  },
  cerrarRegistrar(){
    this.showRegistrarCliente = false
  },
  handleExitoRegistrar(dataCliente){
    this.dataCliente = dataCliente
    this.showRegistrarCliente = false
    this.showConfirmarNuevo = true
  },
  exitoCrearCita(mensaje){
    this.dataCliente = null
    this.showCrearCita = false
    this.showModalExito = true
    this.mensajeExito = mensaje
    this.getAppoinments()
  },
  fallaCrearCita(mensaje){
    this.dataCliente = null
    this.showCrearCita = false
    this.showModalError = true
    this.mensajeError = mensaje
  },
  cerrarCrearCita(){
    this.dataCliente = null
    this.showCrearCita = false
  },
  showCrear(){
    this.showCrearCita = true
  },
  closeModalExito(){
    this.showModalExito = false
    this.showModalError = false
  },
  editStatus(status){
    if(status.status == 1) return
     this.statusSeleccionado = status
     this.showEditar = true
    },
    async editarStatus(status){
      try {
        this.loading = true
        await AppoinmentService.updateStatus(status)
       this.loading = false
       this.showEditar = false
       this.showModalExito = true
       this.mensajeExito = "El estatus de la cita ha sido cambiada con éxito."
      } catch (error) {
        this.showEditar = false
        this.showModalError = true
        console.log(error)
        this.mensajeError = error.data.message
        this.citas = []
    this.getAppoinments()
        this.loading = false
        console.log(error)
      }
    },
  handleDates(dates){
    this.page = 1
    const {fechaInicio,fechaFin} = dates
    this.fechaInicio = fechaInicio
    this.fechaFin = fechaFin
    this.getAppoinments()
  },
  searchNewPage(page){
    this.page = page
    this.getAppoinments()
  },
  handleStatus(status){
    this.page = 1
    this.status = status
    this.getAppoinments()
  },
  handleBusqueda(busqueda){
    this.page = 1
    this.busqueda = busqueda
    this.getAppoinments()
  },
  async getAppoinments (){
  try {
    this.loading = true
    const data = {
      status:this.status,
      busqueda:this.busqueda,
      fechaInicio:this.fechaInicio,
      fechaFin:this.fechaFin,
      page:this.page
    }
    const res = await AppoinmentService.getAppoinments(data)
    this.citas = res.appoinment
    this.totalPages = res.totalPages
    console.log(res)
    this.loading = false
  } catch (error) {
    this.loading = false
    console.log(error)
  }
  
}
},
mounted(){
this.getAppoinments()
},

}
</script>

<style>

.position{
  position: absolute;
  top:0;
  left: 0;
}
.table-wrapper{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 4px;
height: 100%;
width: 100%;
}
.footer-container{
  background-color: #FFFFFF;
  /* height: 150px; */
  display: flex;
  flex-direction: column;
}
.btn-cita{
height: 66px;
width: 66px;
align-self: flex-end;
justify-self: flex-end;
cursor: pointer;
margin-right: 40px;
}
#footer{
  justify-content: center;
  align-content: flex-end;
}

</style>